import locationsService from '@/api/locationsService'
import debounce from '@/utils/debounce'
import { mapState } from 'vuex'
import { MODULE_NAME } from '@/store/filters/constants'
import filterUtils from '@/mixins/filterUtils'

const DEBOUNCE_TIME = 500

export default {
  name: 'FilterComponent',
  mixins: [],
  components: {},
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this._search = debounce(this.search, DEBOUNCE_TIME)
    if (this.filter.remote) {
      this.search('')
    }
  },
  data () {
    return {
      query: null,
      remoteOptions: []
    }
  },
  watch: {
    remoteSearchParams () {
      this.search(this.query)
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['filters']),
    valuesWithLabel () {
      return this.filter.value.map(value => {
        const opt = this.optionsForSelect.find(opt => opt.id === value) || {}
        return { id: value, name: opt.name }
      })
    },
    optionsForSelect () {
      return this.filter.remote
        ? this.remoteOptions
        : this.filter.options.map(opt => ({ id: opt.value, name: opt.label }))
    },
    remoteSearchParams () {
      const filterConfig = { ...(this.filter.remote && this.filter.remote.filters) }
      for (const param in filterConfig) {
        const key = filterConfig[param]
        const filter = this.filters.find(f => f.key === key)
        const hasValue = filter && filterUtils.methods.filterHasValue(filter)
        if (hasValue) {
          const value = filter.value instanceof Date
            ? filter.value.toISOString().split('T')[0]
            : String(filter.value)
          filterConfig[param] = value
        } else {
          delete filterConfig[param]
        }
      }
      return filterConfig
    }
  },
  methods: {
    slowSearch (query) {
      this._search(query)
    },
    search (query) {
      this.query = query
      const selection = Array.isArray(this.filter.value) ? this.filter.value : []
      const params = {
        q: query,
        ...this.remoteSearchParams
      }

      if (this.filter.remote.url === '/shops') {
        params.ordering = 'name'
      }

      if (this.filter.remote.url === '/campaigns/products') {
        params.page = 1
        params.page_size = 10
      }

      locationsService.getAutocompletion({
        config: this.filter.remote,
        params,
        selection
      })
        .then(data => {
          const options = data.map(opt => ({ id: opt.value || opt.id, name: opt.label || opt.name, ...opt }))
          this.$nextTick(() => {
            this.remoteOptions = options
          })
        })
    },
    setSelect (item) {
      if (this.selectedItems.find(s => s.id === item.id)) {
        this.selectedItems = this.selectedItems.filter(s => s.id !== item.id)
        this.$emit('change', { id: item.id, state: false })
      } else {
        this.selectedItems.push(item)
        this.$emit('change', { id: item.id, state: true })
      }
    },
    isOptionSelected (opt) {
      const value = opt.value || opt.id
      return this.filter.multiple
        ? this.filter.value.indexOf(value) !== -1
        : this.filter.value === value
    },
    onSelectChange (opt) {
      let value = null
      if (this.isOptionSelected(opt)) {
        value = this.filter.value.filter(v => v !== opt.id)
      } else {
        value = this.filter.value.concat(opt.id)
      }
      this.$emit('change', value)
    },
    onFilterToggle (tag) {
      const value = tag.state ? tag.id : null
      this.$emit('change', value)
    },
    onFilterToggleMultiple (tag) {
      let value = null
      if (tag.state) {
        value = this.filter.value.concat(tag.id)
      } else {
        value = this.filter.value.filter(v => v !== tag.id)
      }
      this.$emit('change', value)
    }
  }
}
